import {
  PathsV1RelocationOrderSearchPostParametersQueryOrderByDirection,
  PathsV1RelocationOrderSearchPostParametersQueryOrderByField,
} from "@/api-schema-enums";
import { createRowNavigatePath } from "@/components/data-table/_helpers/create-row-navigate-path";
import { RelocationOrderTable } from "@/components/data-table/predefined/relocation-order-table";
import { relocationTableOrderDefaultColumns } from "@/components/data-table/predefined/relocation-order-table-columns";
import { DataTableHeightMode } from "@/components/data-table/types";
import { useTranslation } from "react-i18next";

const VEHICLE_RELOCATION_ORDER_PAGE_SIZE = 500;

const VEHICLE_RELOCATION_ORDER_ORDER_BY = [
  {
    direction: PathsV1RelocationOrderSearchPostParametersQueryOrderByDirection.Desc,
    field: PathsV1RelocationOrderSearchPostParametersQueryOrderByField.CreatedAt,
  },
] as const;

const VEHICLE_RELOCATION_ORDER_COLUMNS = [
  relocationTableOrderDefaultColumns.mobile.columnMobileOrderInformation,
  relocationTableOrderDefaultColumns.tablet.columnOrderInformation,
  relocationTableOrderDefaultColumns.desktop.columnOrderInformation,
  relocationTableOrderDefaultColumns.widescreen.columnTransportReason,
  relocationTableOrderDefaultColumns.widescreen.columnTransportMethod,
  relocationTableOrderDefaultColumns.widescreen.columnTransportCompany,
  relocationTableOrderDefaultColumns.widescreen.columnOrderedBy,
  relocationTableOrderDefaultColumns.widescreenAndDesktop.columnInternalRouteWithStatus,
  relocationTableOrderDefaultColumns.widescreenAndDesktop.columnEarliestPickupDate,
];

export function RelocationOrdersTab({ uuid }: { uuid: string }) {
  const { t } = useTranslation(["fit", "masterdata"]);

  return (
    <section className="space-y-4">
      <div>
        <h2 className="text-xl font-semibold">{t("fit:RelocationOrders")}</h2>
        <p className="text-muted-foreground text-sm">{t("masterdata:VehicleRelocationOrdersDescription")}</p>
      </div>

      <RelocationOrderTable
        name={`vehicle-detail-relocation-orders-${uuid}`}
        body={{ vehicle: [uuid] }}
        query={{ orderBy: [...VEHICLE_RELOCATION_ORDER_ORDER_BY] }}
        columns={VEHICLE_RELOCATION_ORDER_COLUMNS}
        pageSize={VEHICLE_RELOCATION_ORDER_PAGE_SIZE}
        heightMode={DataTableHeightMode.Content}
        disableUrlPersistence={true}
        features={{
          expansion: false,
          multiSelection: false,
          pagination: false,
          search: false,
        }}
        noDataTitle={t("fit:NoRelocationOrdersFound")}
        noDataDescription={t("masterdata:NoVehicleRelocationOrdersForVehicle")}
        onRowNavigate={createRowNavigatePath("/fit/relocation-order")}
      />
    </section>
  );
}
